// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XEKe","placeholdersHeader":"styles_placeholdersHeader__1ACrP","editorStyle":"styles_editorStyle__3LEgp","placeholdersBox":"styles_placeholdersBox__3vY6x"};